import "./CustomizedTable.scss";

import { FC, memo, useEffect, useState } from "react";

import type {
  Direction,
  DirectionValues,
  IActiveSorting,
} from "../../hooks/useSortableTable";
import { TriangleArrowIcon } from "../icons";

interface IProps {
  title: string;
  onSort: (orderBy: string, direction: Direction) => void;
  orderBy: string;
  activeSorting: IActiveSorting;
}

const values: DirectionValues = ["desc", "asc", null];
const SortableHeader: React.FC<IProps> = memo(
  ({ title, onSort, orderBy, activeSorting }) => {
    const [sortField, setSortField] = useState<Direction>(null);

    const handleSort = () => {
      const currentIndex = values.indexOf(sortField);
      const nextIndex = (currentIndex + 1) % values.length;
      setSortField(values[nextIndex]);
      onSort && onSort(orderBy, values[nextIndex]);
    };

    useEffect(() => {
      if (activeSorting.orderBy === orderBy) {
        setSortField(activeSorting.direction);
      } else {
        setSortField(null);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSorting]);

    const extraClassName = sortField
      ? sortField === "asc"
        ? "asc-sorted"
        : ""
      : "not-active";

    return (
      <div role="presentation" className="sortable-header">
        <span className="">
          <button
            type="button"
            className="sortable-header__button d-flex align-items-center"
            onClick={handleSort}
          >
            <div className="sortable-header__title position-relative ">
              {title}
            </div>
            <span className={`d-flex align-items-center ${extraClassName}`}>
              <TriangleArrowIcon />
            </span>
          </button>
        </span>
      </div>
    );
  },
);

export { SortableHeader };
